import { render } from "./SeekbarComponent.vue?vue&type=template&id=78878712"
import script from "./SeekbarComponent.vue?vue&type=script&lang=ts"
export * from "./SeekbarComponent.vue?vue&type=script&lang=ts"
script.render = render

export default script